import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { MapPin, Phone, Clock, Navigation, MessageCircle } from 'lucide-react';

const ContactSection = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-black to-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Crimson Text', serif" }}>
            {t.contact_title}
          </h2>
          <p className="text-xl text-white/80">
            {t.contact_subtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Contact Information */}
          <div className="space-y-6">
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
              <div className="space-y-6">
                {/* Address */}
                <div className="flex items-start gap-4">
                  <MapPin className="w-6 h-6 text-[#d4af37] flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="text-white font-semibold text-lg mb-1">{t.address}</h3>
                    <p className="text-white/70">Kaiser-Friedrich-Straße 49</p>
                    <p className="text-white/70">10627 Berlin, Charlottenburg</p>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex items-start gap-4">
                  <Phone className="w-6 h-6 text-[#d4af37] flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="text-white font-semibold text-lg mb-1">{t.phone}</h3>
                    <a href="tel:+493089542916" className="text-white/70 hover:text-[#d4af37] transition-colors duration-200">
                      +49 30 8954 2916
                    </a>
                  </div>
                </div>

                {/* Hours */}
                <div className="flex items-start gap-4">
                  <Clock className="w-6 h-6 text-[#d4af37] flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="text-white font-semibold text-lg mb-1">{t.hours}</h3>
                    <p className="text-white/70">{t.hours_value}</p>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="mt-8 space-y-3">
                <a
                  href="https://www.google.com/maps/dir//Kaiser-Friedrich-Straße+49,+10627+Berlin"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 w-full bg-[#d4af37] text-black px-6 py-4 rounded-lg font-bold hover:bg-[#f0c24d] transition-all duration-300 transform hover:scale-105"
                >
                  <Navigation className="w-5 h-5" />
                  {t.get_directions}
                </a>

                <a
                  href="tel:+493089542916"
                  className="flex items-center justify-center gap-2 w-full bg-white/10 text-white px-6 py-4 rounded-lg font-bold border-2 border-white/20 hover:bg-white hover:text-black transition-all duration-300 transform hover:scale-105"
                >
                  <Phone className="w-5 h-5" />
                  {t.call_now}
                </a>

                <a
                  href="https://wa.me/493089542916"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 w-full bg-green-500/20 text-white px-6 py-4 rounded-lg font-bold border-2 border-green-500/30 hover:bg-green-500 hover:border-green-500 transition-all duration-300 transform hover:scale-105"
                >
                  <MessageCircle className="w-5 h-5" />
                  {t.whatsapp_us}
                </a>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl overflow-hidden border border-white/10 h-[600px]">
            <iframe
              src="https://maps.google.com/maps?q=Corbaci+Berlin+Kaiser-Friedrich-Straße+49&t=&z=16&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Corbaci Restaurant - Kaiser-Friedrich-Straße 49, 10627 Berlin"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
